export default __webpack_public_path__ + "static/media/Rani-ka-Talab.1ba31b38.jpg";